import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../store/root-reducer';
import {
  getMyTemplateRequest,
  getTeamTemplateRequest,
} from '../../../extra-actions';
import {
  CreateTemplateRequest,
  GetTemplatesRequest,
} from '../../../../templates/types/request';
import { Template } from './types';
import TemplateModal from './template-modal';
import { createTemplateRequest } from '../../../../templates/extra-actions';
import { resetTemplates } from '../../../../templates/templates-slice';

const mapStateToProps = (state: RootState) => ({
  myTemplates: state.sequence.myTemplates,
  myTemplatesMeta: state.sequence.myTemplatesMeta,
  getMyTemplateRequestStatus: state.sequence.getMyTemplateRequest.status,
  getMyTemplateRequestError: state.sequence.getMyTemplateRequest.error,

  teamTemplates: state.sequence.teamTemplates,
  teamTemplatesMeta: state.sequence.teamTemplatesMeta,
  getTeamTemplateRequestStatus: state.sequence.getTeamTemplateRequest.status,
  getTeamTemplateRequestError: state.sequence.getTeamTemplateRequest.error,

  // Create template requests
  createTemplateRequestStatus: state.templates.createTemplateRequest.status,
  createTemplateRequestError: state.templates.createTemplateRequest.error,
  createTemplateRequestMessage: state.templates.createTemplateRequest.message,
});

const mapDispatchToProps = {
  sendGetMyTemplateRequest: (args: GetTemplatesRequest) =>
    getMyTemplateRequest(args),
  sendGetTeamTemplateRequest: (args: GetTemplatesRequest) =>
    getTeamTemplateRequest(args),
  sendCreateTemplateRequest: (args: CreateTemplateRequest) =>
    createTemplateRequest(args),
  resetTemplateState: () => resetTemplates(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  show: boolean;
  onClose: VoidFunction;
  onTemplateChange: (selectedTemplate: Template) => void;
};

export default connector(TemplateModal);
